import {Autocomplete, Button, IconButton, Stack, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {FiTrash2} from "react-icons/fi";
import {scopesColumns} from "../../constants/dataGridColumns";
import ListView from "../ListView/ListView";
import useApiRequest from "../../hooks/useApiRequest";

const ClientScopesGrid = ({clientId}) => {
  const [isSettingNewScope, setIsSettingNewScope] = useState(false);
  const [selectedScopeId, setSelectedScopeId] = useState(null);
  const [scopesSelect, setScopesSelect] = useState([]);

  const {data, loading, list, remove, create} = useApiRequest(`/clients/${clientId}/scopes`);

  const {data: dataScopes, loading: loadingScopes, list: listScopes} = useApiRequest(`/scopes`);

  useEffect(() => {
    list();
    listScopes();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (scopesSelect.length === 0 && dataScopes && data) {
      const clientScopesIds = data?.length > 0 ? data.map((scope) => scope.id) : [];
      const scopesFiltered = dataScopes.filter((scope) => !clientScopesIds.includes(scope.id));
      const transformedList = scopesFiltered.map((scope) => ({
        id: scope.id,
        label: scope.name
      }));
      setScopesSelect(transformedList);
    }
  }, [dataScopes, data, scopesSelect]);

  const handleAccept = async () => {
    if (!selectedScopeId) return;
    const result = await create({scope_id: selectedScopeId});

    if (result.success) {
      setScopesSelect((prev) => prev.filter((scope) => scope.id !== selectedScopeId));
    }
    listScopes();
    list();
  };

  const handleScopeSelect = (event, value) => {
    setSelectedScopeId(value?.id || null);
  };

  const handleRowDelete = async (id) => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este scope?");
    if (confirmDelete) {
      try {
        await remove(id);
        list();
        listScopes();
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
      }
    }
  };

  const columns = [
    ...scopesColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              handleRowDelete(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <ListView
      viewTitle={"Scopes"}
      columns={columns}
      data={data || []}
      loading={loading || loadingScopes}
      TopRigthButtons={
        <Stack direction="row" spacing={2}>
          {isSettingNewScope && (
            <Stack direction="row" spacing={2}>
              <Autocomplete
                disablePortal
                options={scopesSelect}
                sx={{width: 300}}
                onChange={handleScopeSelect}
                renderInput={(params) => <TextField {...params} label="Scope" />}
              />
              <Button variant="contained" onClick={handleAccept}>
                Aceptar
              </Button>
            </Stack>
          )}
          <Button
            variant="contained"
            color={isSettingNewScope ? "error" : "primary"}
            onClick={() => {
              setIsSettingNewScope(!isSettingNewScope);
            }}
          >
            {isSettingNewScope ? "Cancelar" : "Asignar scope"}
          </Button>
        </Stack>
      }
    />
  );
};

export default ClientScopesGrid;
